module.exports = __webpack_public_path__ + "img/sample3.468f43d3.jpg";